import axios from 'axios';
import jwtDecode from 'jwt-decode';

const LoginFunctions = {
  valid: ({ username, password}) => {
    return new Promise((resolve, reject) => {
       axios.post('http://localhost:5000/auth/v1/login', {username, password})
        .then((response) => {
         const decoded = jwtDecode(response.data.auth);
         const payload = {
           token: response.data.auth,
           user: decoded.user,
         }
         localStorage.setItem('@session', JSON.stringify(payload));
         resolve({ session: true });
       }).catch(() => {
         reject({ session: false, message: 'Usuario y/o contraseña incorrectos' });
       })
    }) 
  },
  isAuth: () => {
    let session = localStorage.getItem('@session');
    session = JSON.parse(session);
    //calcular expire
    if (session !== null) {
      return true;
    } else {
      return false;
    }
  }
}

export default LoginFunctions;